import React, { useState } from 'react';
import { Box, Text, IconButton } from '@chakra-ui/react';
import { X } from 'lucide-react';
import { appConfig } from '@/config/app-config';

export const DevBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(false);

  if (appConfig.ENVIRONMENT !== 'development' || dismissed) return null;

  return (
    <Box position="sticky" bottom={0} bg="blue.100" py={2} px={4} textAlign="center" zIndex={20}>
      <Text fontSize="xs" fontWeight="semibold" color="blue.900">
        API_BASE_URL: {appConfig.API_BASE_URL}
      </Text>
      <IconButton
        aria-label="Dismiss dev banner"
        icon={<X size={12} />}
        size="xs"
        variant="ghost"
        colorScheme="blue"
        position="absolute"
        right={2}
        top="50%"
        transform="translateY(-50%)"
        onClick={() => setDismissed(true)}
      />
    </Box>
  );
};

export default DevBanner;
